import { makeStyles } from '@material-ui/core/styles'
import { COLORS } from '../../constants'

export const styles = makeStyles(theme => ({
  uploadInput: {
    display: 'none',
  },
  uploadPicture: {
    display: 'flex',
    alignItems: 'center',
    marginTop: 40,
    marginBottom: 40,
  },
  uploadPictureContainer: {
    width: '30%',
    maxWidth: 100,
    borderRadius: '100%',
    overflow: 'hidden',
  },
  uploadPictureAvatar: {
    display: 'block',
    position: 'relative',
    width: '100%',
    height: 0,
    paddingBottom: '100%',
    background: 'black',
    borderRadius: '50%',
  },
  birdAvatar: {
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    height: 53,
    maxHeight: 53,
    width: 49,
    maxWidth: 49,
    margin: 'auto',
    display: 'block',
    position: 'absolute',
  },
  userAvatar: {
    width: 100,
    height: 100,
    objectFit: 'cover',
    borderRadius: '50%',
  },
  modal: {
    position: 'fixed',
    display: 'flex',
    justifyContent: 'center',
    zIndex: 100,
    paddingTop: 100,
    left: 0,
    top: 0,
    width: '100%',
    height: '100%',
    overflow: 'auto',
    backgroundColor: 'rgba(0, 0, 0, 0.9)',
  },
  modalContent: {
    display: 'block',
    width: '80%',
    maxWidth: '600px',
    height: '600px',
    WebkitAnimationName: 'zoom',
    WebkitAnimationDuration: '0.6s',
    animationName: 'zoom',
    animationDuration: '0.6s',
    ['@media only screen and (max-width: 700px)']: {
      // eslint-disable-line no-useless-computed-key
      width: 100,
    },
  },
  close: {
    marginLeft: '25px',
    marginTop: '-40px',
    order: 1,
    color: '#f1f1f1',
    fontSize: '50px',
    fontWeight: 'bold',
    transition: '0.3s',
    '&:hover': {
      color: '#bbb',
      textDecoration: 'none',
      cursor: 'pointer',
    },
    '&:focus': {
      color: '#bbb',
      textDecoration: 'none',
      cursor: 'pointer',
    },
  },
  spinner: {
    position: 'absolute',
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  profileActive: {
    position: 'absolute',
    bottom: -6,
    left: 0,
  },
  profileMedia: {},
  uploadImage: {
    width: 30,
    height: 30,
    borderRadius: '50%',
    background: '#fff',
    display: 'block',
    padding: '6px 9px',
    textAlign: 'center',
    position: 'absolute',
    bottom: '-2px',
    left: 0,
  },
}))
